import qnamain       from '@/pages/qna/qna-main/QnaMain.vue'
import qna       from '@/pages/qna/qna-page/Qna.vue'
import qnaregister       from '@/pages/qna/qna-register'
import qnadetail       from '@/pages/qna/detail'
import faq       from '@/pages/qna/faq/Faq.vue'

export default [
    {
        path: '/qnamain',
        name: 'qnamain',
        component: qnamain,
    },
    {
        path: '/qna',
        name: 'qna',
        component: qna,
    },
    {
        path: '/qnadetail',
        name: 'qnadetail',
        component: qnadetail,
    },
    {
        path: '/qnaregister',
        name: 'qnaregister',
        component: qnaregister,
    },
    {
        path: '/faq',
        name: 'faq',
        component: faq,
    }
]
